<template>
  <main class="terms-page">
    <header class="site-header">
      <img
        class="site-logo"
        :src="logo"
        alt="BOTTIMMO Turkoglu"
      />
    </header>

    <section class="hero">
      <h1>{{ $t('terms-page.title') }}</h1>
    </section>

    <section class="content">
      <div class="content-container">
        <section class="legal-section">
          <h2>{{ $t('terms-page.main.title') }}</h2>

          <p>{{ $t('terms-page.main.intro') }}</p>

          <h3>{{ $t('terms-page.parties.title') }}</h3>

          <p>{{ $t('terms-page.parties.content.0') }}</p>
          <p>{{ $t('terms-page.parties.content.1') }}</p>

          <h3>{{ $t('terms-page.service.title') }}</h3>

          <p>{{ $t('terms-page.service.content.0') }}</p>
          <p>{{ $t('terms-page.service.content.1') }}</p>

          <h3>{{ $t('terms-page.duration.title') }}</h3>

          <p>{{ $t('terms-page.duration.content.0') }}</p>
          <p>{{ $t('terms-page.duration.content.1') }}</p>
          <p>{{ $t('terms-page.duration.content.2') }}</p>
          <p>{{ $t('terms-page.duration.content.3') }}</p>

          <h3>{{ $t('terms-page.payment.title') }}</h3>

          <p>{{ $t('terms-page.payment.content.0') }}</p>
          <p>{{ $t('terms-page.payment.content.1') }}</p>

          <h3>{{ $t('terms-page.customer-obligations.title') }}</h3>

          <p>{{ $t('terms-page.customer-obligations.content.0') }}</p>
          <p>{{ $t('terms-page.customer-obligations.content.1') }}</p>
          <p>{{ $t('terms-page.customer-obligations.content.2') }}</p>
          <p>{{ $t('terms-page.customer-obligations.content.3') }}</p>

          <h3>{{ $t('terms-page.intellectual-property.title') }}</h3>

          <p>{{ $t('terms-page.intellectual-property.content') }}</p>

          <h3>{{ $t('terms-page.liability.title') }}</h3>

          <p>{{ $t('terms-page.liability.content') }}</p>

          <h3>{{ $t('terms-page.contract-end.title') }}</h3>

          <p>{{ $t('terms-page.contract-end.content') }}</p>

          <h3>{{ $t('terms-page.changes.title') }}</h3>

          <p>{{ $t('terms-page.changes.content') }}</p>

          <h3>{{ $t('terms-page.law.title') }}</h3>

          <p>{{ $t('terms-page.law.content') }}</p>

          <p class="effective-date">{{ $t('terms-page.effective-date') }}</p>
        </section>
      </div>
    </section>

    <footer class="site-footer">
      <div class="footer-container">
        <div class="footer-links">
          <strong>{{ $t('impressum-page.section-footer.title') }}</strong>

          <a
            target="_blank"
            :href="imprintUrl"
            rel="noopener noreferrer"
          >
            {{ $t('impressum-page.section-footer.content.0') }}
          </a>

          <a
            target="_blank"
            :href="publicDataPrivacyUrl"
            rel="noopener noreferrer"
          >
            {{ $t('impressum-page.section-footer.content.1') }}
          </a>

          <a
            target="_blank"
            :href="publicDataPrivacyUrl"
            rel="noopener noreferrer"
          >
            {{ $t('impressum-page.section-footer.content.2') }}
          </a>
        </div>

        <div class="footer-divider" />

        <div class="footer-company">
          © {{ currentYear }} {{ $t('impressum-page.section-footer.content.3') }}
          <span class="separator">·</span>
          {{ $t('impressum-page.section-footer.content.4') }}
          <br />
          {{ $t('impressum-page.section-footer.content.5') }}
        </div>
      </div>
    </footer>
  </main>
</template>

<script setup>
import { computed } from 'vue'

import logo from '@/assets/img/logo.png'
import { useBranding } from '@/composables/useBranding'

const currentYear = computed(() => new Date().getFullYear())
const { publicDataPrivacyUrl, imprintUrl } = useBranding()
</script>

<style scoped>
.terms-page {
  min-height: 100vh;
  background: #fff;
  color: #303030;
  font-family: Inter, Arial, Helvetica, sans-serif;
}

.site-header {
  height: 82px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  border-top: 1px solid #e5e5e5;
}

.site-logo {
  display: block;
  width: 300px;
  max-width: 70%;
  max-height: 58px;
  object-fit: contain;
}

.hero {
  min-height: 400px;
  background: #00150d;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
}

.hero h1 {
  margin: 0;
  color: #fff;
  font-size: clamp(40px, 4vw, 64px);
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
}

.content {
  width: 100%;
}

.content-container {
  width: min(100% - 80px, 1240px);
  margin: 0 auto;
  padding: 38px 0 42px;
}

.legal-section {
  margin-bottom: 38px;
}

.legal-section:last-child {
  margin-bottom: 0;
}

.legal-section h2 {
  margin: 0 0 20px;
  text-align: center;
  color: #303030;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.25;
}

.legal-section h3 {
  margin: 32px 0 14px;
  color: #303030;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.25;
}

.legal-section p {
  margin: 0 0 16px;
  color: #8d8d8d;
  font-size: 24px;
  line-height: 1.48;
}

.legal-section p strong {
  color: #303030;
  font-weight: 700;
}

.effective-date {
  margin-top: 32px;
  font-weight: 700;
}

.site-footer {
  width: 100%;
  border-top: 1px solid #ededed;
  background: #fff;
}

.footer-container {
  width: min(100% - 80px, 1120px);
  margin: 0 auto;
  padding: 56px 0 32px;
}

.footer-links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  font-size: 20px;
  line-height: 1.35;
}

.footer-links strong {
  font-weight: 700;
}

.footer-links a {
  color: inherit;
  text-decoration: none;
}

.footer-links a:hover {
  text-decoration: underline;
}

.footer-divider {
  height: 1px;
  width: 100%;
  background: #e5e5e5;
  margin: 42px 0 28px;
}

.footer-company {
  color: #696969;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.45;
}

.separator {
  display: inline-block;
  padding: 0 8px;
}

@media (max-width: 900px) {
  .site-header {
    height: 72px;
  }

  .site-logo {
    width: 240px;
  }

  .hero {
    min-height: 300px;
  }

  .content-container {
    width: min(100% - 48px, 1240px);
    padding-top: 34px;
  }

  .legal-section h2 {
    font-size: 24px;
  }

  .legal-section h3 {
    font-size: 21px;
  }

  .legal-section p {
    font-size: 19px;
  }

  .footer-container {
    width: min(100% - 48px, 1120px);
  }
}

@media (max-width: 600px) {
  .site-header {
    height: 64px;
    padding: 10px 16px;
  }

  .site-logo {
    width: 200px;
  }

  .hero {
    min-height: 220px;
    padding: 40px 20px;
  }

  .hero h1 {
    font-size: 36px;
  }

  .content-container {
    width: calc(100% - 32px);
    padding: 28px 0 32px;
  }

  .legal-section {
    margin-bottom: 32px;
  }

  .legal-section h2 {
    margin-bottom: 16px;
    font-size: 21px;
  }

  .legal-section h3 {
    margin-top: 26px;
    margin-bottom: 10px;
    font-size: 19px;
  }

  .legal-section p {
    font-size: 17px;
    line-height: 1.5;
  }

  .footer-container {
    width: calc(100% - 32px);
    padding: 40px 0 24px;
  }

  .footer-links {
    font-size: 17px;
  }

  .footer-divider {
    margin: 32px 0 22px;
  }

  .footer-company {
    font-size: 14px;
  }

  .separator {
    padding: 0 4px;
  }
}
</style>
